import { computed } from "vue";
import { useStore } from "vuex";
import { StudentState } from "@/store/room/interface";
import { isUserPublishedAudio, isUserPublishedVideo } from "@/store/calling/utils";
import { MODULES, vuexName } from "@/store/utils";

export enum RoomStore {
  Teacher = 0,
  Student = 1,
}
export const useRoomStore = (room: RoomStore) => {
  const module = room === RoomStore.Teacher ? "teacherRoom" : "studentRoom";
  const { getters } = useStore();
  const students = computed<StudentState[]>(
    () =>
      getters[module === "teacherRoom" ? vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_STUDENTS) : vuexName(MODULES.STUDENT_ROOM.GETTERS.GET_STUDENTS)],
  );
  const oneStudentIds = computed<string[]>(
    () =>
      getters[
        module === "teacherRoom"
          ? vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_ONE_TO_ONE_STUDENT_IDS)
          : vuexName(MODULES.STUDENT_ROOM.GETTERS.GET_ONE_TO_ONE_STUDENT_IDS)
      ],
  );
  const callingUserIds = computed<string[]>(() => getters[vuexName(MODULES.CALLING.GETTERS.GET_CALLING_USER_IDS)]);
  const studentIdsNotInOneToOneMode = computed<string[]>(
    () =>
      getters[
        module === "teacherRoom"
          ? vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_NOT_ONE_TO_ONE_STUDENT_IDS)
          : vuexName(MODULES.STUDENT_ROOM.GETTERS.GET_NOT_ONE_TO_ONE_STUDENT_IDS)
      ],
  );
  const isAllOnlineStudentsVideoHidden = computed<boolean>(() =>
    students.value
      .filter((student) => callingUserIds.value.includes(student.id))
      .every((student) => !isUserPublishedVideo({ userId: student.id, gettersOrRootGetters: getters })),
  );
  const isAllOnlineStudentsAudioMuted = computed<boolean>(() =>
    students.value
      .filter((student) => callingUserIds.value.includes(student.id))
      .every((student) => !isUserPublishedAudio({ userId: student.id, gettersOrRootGetters: getters })),
  );
  const isAllOnlineStudentsDisabledPalette = computed<boolean>(() =>
    students.value.filter((student) => callingUserIds.value.includes(student.id)).every((student) => !student.isPalette),
  );
  const onlineStudentIdsNotInOneToOneMode = computed<string[]>(() =>
    studentIdsNotInOneToOneMode.value.filter((id) => callingUserIds.value.includes(id)),
  );

  const currentOnlineEnabledPaletteStudent = computed<StudentState | undefined>(() =>
    students.value.find((student) => student.isPalette && callingUserIds.value.includes(student.id)),
  );

  return {
    students,
    oneStudentIds,
    onlineStudentIdsNotInOneToOneMode,
    isAllOnlineStudentsVideoHidden,
    isAllOnlineStudentsAudioMuted,
    isAllOnlineStudentsDisabledPalette,
    currentOnlineEnabledPaletteStudent,
  };
};
